import {
  createHeader,
  createAlignedHeader,
  createBulletPoint,
  createSpacingLine,
} from "./componentHelpers"

export const renderCertificateSection = certificateExperiences => {
  if (!certificateExperiences || certificateExperiences.length === 0) {
    return []
  }
  
  return [
    createHeader("LICENSES AND CERTIFICATIONS"),
    ...certificateExperiences
      .filter(experience => experience)
      .flatMap(experience => {
        const title = experience.title || "CERTIFICATE TITLE"
        const issuer = experience.issuer || "ISSUER"
        const bulletPoints = experience.bulletPoints || []
        const date = experience.endDate || ""

        return [
          createAlignedHeader(title, issuer, "", date),
          ...bulletPoints.map(b => createBulletPoint(b)),
          createSpacingLine,
        ]
      }),
  ]
}
